import {
  DList,
  DListResponse,
  DObjectResponse,
  TriggerTypes,
} from 'models/common.model';

export enum PhotoFilterEnum {
  FUN = 1,
  FACE_BEAUTY_PRO = 2,
  FACE_BEAUTY = 3,
  SMART_BEAUTY = 4,
  OPENCV_BEAUTY = 5,
  DEEP_BEAUTY_IMAGE = 6,
}

export type PhotoFilterModel = {
  apiUrl: string;
  color: string;
  id: number;
  isActive: true;
  matrix: string;
  name: string;
  orderNo: number;
  thumbnailUrl: string;
  type: string;
};

export type GetPhotoFilterRequestModel = {
  id?: number;
};
export type GetPhotoFilterResponseModel = DObjectResponse<PhotoFilterModel>;

export type ListPhotoFilterRequestModel = {
  pageIndex?: number;
  pageSize?: number;
  name?: string;
  isActive?: boolean | null;
  orderByName?: string;
  orderByType?: string;
};
export type ListPhotoFilterResponseModel = DListResponse<PhotoFilterModel>;

export type SavePhotoFilterRequestModel = {
  id?: number;
  apiUrl?: string;
  color?: string;
  isActive?: true;
  matrix?: string | null;
  name: string;
  orderNo?: number;
  thumbnailUrl?: string;
  type?: string;
};
export type SavePhotoFilterResponseModel = DObjectResponse<boolean>;

export type DeletePhotoFilterRequestModel = {
  id?: number;
};
export type DeletePhotoFilterResponseModel = DObjectResponse<boolean>;

export type InactivePhotoFilterRequestModel = {
  id?: number;
};
export type InactivePhotoFilterResponseModel = DObjectResponse<boolean>;

export type ActivePhotoFilterRequestModel = {
  id?: number;
};
export type ActivePhotoFilterResponseModel = DObjectResponse<boolean>;

export interface PhotoFilterStateModel {
  photoFilterListData: DList<PhotoFilterModel> | null;
  photoFilterDetail: PhotoFilterModel | null;
  triggerSavePhotoFilter: TriggerTypes | null;

  loadingList: boolean;
  loadingDetail: boolean;
}
